// API Configuration - Docker, Local ve Native App uyumlu
// Docker'da: nginx/apache proxy kullanılır, relative path yeterli
// Local'de: doğrudan backend'e bağlanır
// Native App'te: tam URL kullanılır

import { Capacitor } from '@capacitor/core';

const isDevelopment = process.env.NODE_ENV === 'development';
const isNativeApp = Capacitor.isNativePlatform();

// Native app ALWAYS uses production URL (ignore NODE_ENV)
// Web app: production'da proxy, development'ta direkt backend
export const API_URL = isNativeApp
  ? 'https://akikapi.qubite.net/api'
  : isDevelopment
    ? `http://${window.location.hostname}:3001/api`
    : '/api';

export const API_HOST = isNativeApp
  ? 'https://akikapi.qubite.net'
  : isDevelopment
    ? `http://${window.location.hostname}:3001`
    : '';

// Debug logging for native apps
if (isNativeApp) {
  console.log('🚀 Native App Mode - Using Production API:', API_URL);
}

export default API_URL;
